<button 
  class="btn-icon" 
  type="button"
  [class]="iconButtonClasses()"
  [awTooltip]="tooltip()"
  [actionTooltip]="true"
  [fromTop]="tooltipOnTop()"
>
  <i awIcon class="aw-2-icn">{{ icon() }}</i>
</button>
